export const normalizeThreadStatus = (status) =>
  String(status || "")
    .trim()
    .toLowerCase()
    .replace(/\s+/g, "_");

export const resolveThreadStatus = (thread) =>
  thread?.status ?? thread?.threadStatus ?? "";

export const isThreadCompleted = (threadOrStatus) => {
  if (threadOrStatus && typeof threadOrStatus === "object") {
    if (threadOrStatus.completedAt) {
      return true;
    }
    return normalizeThreadStatus(resolveThreadStatus(threadOrStatus)) === "completed";
  }

  return normalizeThreadStatus(threadOrStatus) === "completed";
};

export const getThreadStatusDisplay = (threadOrStatus) => {
  if (threadOrStatus && typeof threadOrStatus === "object") {
    if (isThreadCompleted(threadOrStatus)) {
      return { color: "success", label: "Completed" };
    }
    return getThreadStatusDisplay(resolveThreadStatus(threadOrStatus));
  }

  const normalized = normalizeThreadStatus(threadOrStatus);

  if (normalized === "completed" || normalized === "complete") {
    return { color: "success", label: "Completed" };
  }
  if (normalized === "pending") {
    return { color: "blue", label: "Pending" };
  }
  if (normalized === "in_review") {
    return { color: "orange", label: "In Review" };
  }

  return { color: "default", label: threadOrStatus || "Unknown" };
};
